(function ($) {
	const $buttons = $('.js-read-more');

	$buttons.each(setup);

	function setup() {
		const $button = $(this);
		let id = $button.attr('id');

		if (!id) {
			id = 'read-more-' + Math.floor(Math.random() * 1000000);
			$button.attr('id', id);
		}

		const $content = $button.nextAll();

		// add content wrapper after the button and add all the button's siblings to it
		const $wrap = $(`<div id="${id}--content" class="js-read-more-content"></div>`).insertAfter(
			$button,
		);

		$content.appendTo($wrap);

		// hide all content
		$wrap.hide();

		$wrap.attr('aria-hidden', 'true');

		$button.attr('aria-expanded', 'false');
		$button.attr('aria-controls', $wrap.attr('id'));

		const $buttonClone = $button.clone();

		$buttonClone.appendTo($wrap);

		// change id
		$buttonClone.attr('id', `${id}--clone`);
		$buttonClone.addClass('read-less-button');
		$buttonClone.find('span').text('Read less');

		$button.on('click', toggleContent);
		$buttonClone.on('click', toggleContent);
	}

	function toggleContent() {
		const $button = $(this);
		const controlsID = $button.attr('aria-controls');
		const $content = $(`#${controlsID}`);
		const $allButtons = $('[aria-controls="' + controlsID + '"]');

		$content.slideToggle(300);
		$content.attr('aria-hidden', $content.attr('aria-hidden') === 'true' ? 'false' : 'true');

		$allButtons.attr('aria-expanded', $content.attr('aria-hidden') === 'true' ? 'false' : 'true');
	}
})(jQuery);
